import { Box, Button } from '@chakra-ui/react';
import React from 'react';
import { SidebarItemProps } from '../interfaces/components';

function SidebarItem({
  sideBarItemKey,
  sideBarIcon,
  text,

  active,

  setActiveView,
}: SidebarItemProps) {
  return (
    <>
      <Box display={['block', 'block', 'none']}>
        <Button
          display="flex"
          flexDirection="column"
          borderRadius="12px"
          leftIcon={sideBarIcon}
          variant="ghost"
          color={active ? '#5772FF' : '#000'}
          textTransform="capitalize"
          fontSize={['14px']}
          onClick={() => setActiveView(sideBarItemKey)}
          fontWeight={500}
          fontStyle="normal"
          width="inherit"
          transition="0.2s all"
        >
          {text}
        </Button>
      </Box>
      <Box width={['100%']} height={['50px']} display={['none', 'none', 'flex']} alignItems="center">
        <Button
          borderRadius="12px"
          leftIcon={sideBarIcon}
          variant="ghost"
          background={active ? '#5772FF' : 'unset'}
          color={active ? 'white' : '#000'}
          _hover={{
            bg: active ? '#5772FF' : 'unset',
            color: '#000',
          }}
          _active={{
            bg: '#4096FF',
            color: 'white',
          }}
          textTransform="capitalize"
          fontSize={['14px']}
          onClick={() => setActiveView(sideBarItemKey)}
          fontWeight={500}
          fontStyle="normal"
          width="inherit"
          justifyContent="flex-start"
          transition="0.2s all"
        >
          {text}
        </Button>
      </Box>
    </>
  );
}

export default SidebarItem;
